import PropTypes from 'prop-types';
import React from 'react';

import ResponsiveImage from 'components/ResponsiveImage';
import { IMAGE_WIDTHS } from 'constants/images';
import { cn } from 'utils/Tailwind';

const UgcCarouselCard = ({ subtext, src, className }) => (
  <div className={cn('relative aspect-6/7 h-full w-full', className)}>
    <ResponsiveImage src={src} alt={subtext} width={IMAGE_WIDTHS.W_800} ratio="6:7" />
    {subtext && (
      <p className="absolute inset-x-3 bottom-3 text-sm/none font-bold text-white md:inset-x-4 md:bottom-4">
        {subtext}
      </p>
    )}
  </div>
);

UgcCarouselCard.propTypes = {
  src: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  className: PropTypes.string,
};

UgcCarouselCard.defaultProps = {
  subtext: null,
};

export default UgcCarouselCard;
